module.exports = __webpack_public_path__ + "ui-static/img/favicon.3640ab12.svg";